$(document).ready(function(){
  console.log("custom script ready");
  
  const headerContainer = $(".xs-header-container");
  const headerHeight = headerContainer.height();
  const topBar = $(".top_bar");
  
  $(window).scroll(function(){
    const fromTop = $(window).scrollTop();

    if( fromTop > 160 ){
      headerContainer.addClass('xs-header-fixed');
      topBar.addClass('xs-top-bar-fixed');
      $("body").css('paddingTop',`${headerHeight}px`);
    } else {
      headerContainer.removeClass('xs-header-fixed');
      topBar.removeClass('xs-top-bar-fixed');
      $("body").css('paddingTop',`0px`);
    }
  });
  
  
  // product tabs 
  
  if ( window.xs_product_description != undefined ){
    let xsc = $(`<div>${window.xs_product_description}</div>`); 
    
    console.log(xsc);
    
    const shortBrief = $("#xs-short-desc");
    
    const tabsHead = $("#xs-tabs-head");
    const tabsContent = $("#xs-tabs-content");
    
    xsc.find('h2').each(function(){
      const tabTitle = $(this).text();
      const tabContent = $(this).nextUntil("h2");
      const tabHandle = tabTitle.toLowerCase().trim().replace(/ /g, "-");
      
      console.log(tabTitle);
      console.log($("<div></div>").append(tabContent).html());
      if (tabHandle == "brief") {
        shortBrief.show().find('div').html($("<div></div>").append(tabContent).html());
      } else {
        const tabHeadEl = $(`<li data-tab="#xstab-${tabHandle}">${tabTitle}</li>`);
        const tabContentEl = $(`<div id="xstab-${tabHandle}"></div>`).hide();
        tabContent.each(function(){
        	tabContentEl.append($(this));
        });
        
        tabHeadEl.appendTo(tabsHead);
        tabContentEl.appendTo(tabsContent);

        console.log(tabContentEl);
        console.log("----");
        tabHeadEl.on('click', function(){
          let c = $(this).attr('data-tab');
          $(c).show().siblings().hide();
          
          $(this).addClass('xs-tab-active').siblings().removeClass('xs-tab-active');
        });
      }
    });
    
    tabsHead.find('li').first().addClass('xs-tab-active');
    tabsContent.find('div').first().show();
    
    
    $("#xs-go-to-details").on('click',function(e){
      e.preventDefault();

      $([document.documentElement, document.body]).animate({
        scrollTop: $("#more-details").offset().top - ($(window).height() /3  )
      }, 800);
    });
    
  }
  
  
  $(".xs-faq-q").on('click',function(){
    const a = $(this).next('.xs-faq-a');
    const q = $(this);
    if( q.hasClass('open') ){
      a.slideUp();
      q.removeClass('open');
    } else {
      a.slideDown();
      q.addClass('open');
    }
  });
  
  $('[data-xs-terms-valid]').on('click',function(e){
    if(! $(this).closest('form').find("#xs-terms-check").is(':checked') ){
      e.preventDefault();
      $(this).closest('form').find(".data-xs-terms-alert").show();
    }
  });
  $(".xs-terms-check").on('change',function(){
    let isChecked = $(this).is(":checked");
    if( isChecked ){
       $(this).closest('form').find(".data-xs-terms-alert").hide();
//       $('[data-xs-terms-valid]').prop('disabled', false);
    } else {
//       $('[data-xs-terms-valid]').prop('disabled', true);
    }
  });

  $(".xs-faq-sidebar-inner a").off('click').on("click",function(e){
    e.preventDefault();
    let v = $(this).attr('href');
    let headerHeight =  0;
    console.log($(v));
    console.log($(v).offset());
    console.log($(v).offset().top);
    console.log($(v).offset().top - headerHeight - 100 );
    
    if($(".xs-header-fixed").length > 0 ){
     headerHeight = $(".xs-header-fixed").height() ;
    }
    $('html, body').animate({
      scrollTop: $(v).offset().top - 170 
    }, 1000)
  });
  
  $("[data-xs-l-tab]").on('click',function(){
    const t = $(this),
          ta = $(t.attr('data-xs-l-tab'));
    t.siblings().removeClass('active-tab');
    t.addClass('active-tab');
    
    ta.siblings().hide();
    ta.show();
  })
});